import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../redux/store';
import { addCommand } from "../../../redux/actions/commands.actions";
import { useSearchParams } from "react-router-dom";
import { ModalProps } from "../../../components/common/Interfaces/Modals";
import ModalShell from "../../../components/common/Modals/ModalShell";

const AddCommandModal: React.FC<ModalProps> = ({open, setOpen}) => {
    const searchParams = useSearchParams()[0];

    const handleClose = () => {
      handleReset();
      setOpen(false);
    };

    const handleReset = () => {
      setSubmitted(false);
      setTitle('');
      setBody('');
    };

    const dispatch = useDispatch<AppDispatch>();
    const { accessToken } = useSelector((state: RootState) => state.user);
    const { error, loading } = useSelector((state: RootState) => state.commands);

    const [submitted, setSubmitted] = useState(false);
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault();
      setSubmitted(true);
      await dispatch(addCommand({title:title, body:body, params:searchParams.toString()}));
    };

  const editing = !submitted || loading;

  return (
    <ModalShell
      open={open}
      onClose={handleClose}
      size={editing ? "md" : "sm"}
      busy={submitted && loading}
      tone={editing ? undefined : error ? "error" : "success"}
      title={editing ? (submitted && loading ? "Creating command…" : "New command") : error ? "An error occurred" : "Command added"}
      actions={editing ?
        <>
          <button className="btn" onClick={handleClose}>Cancel</button>
          <button className="btn btn-primary" disabled={loading || !accessToken} onClick={handleSubmit}>
            {loading ? "Creating…" : "Create"}
          </button>
        </>
        : error ?
        <>
          <button className="btn" onClick={handleClose}>Close</button>
          <button className="btn btn-primary" onClick={handleReset}>Try again</button>
        </>
        :
        <>
          <button className="btn dlg-actions-start" onClick={handleReset}>Add another</button>
          <button className="btn btn-primary" onClick={handleClose}>Done</button>
        </>
      }
    >
      {editing ?
        <form className="dlg-section" onSubmit={handleSubmit}>
          <div className="field">
            <label className="field-label" htmlFor="title">Title</label>
            <input
              id="title"
              className="input"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              disabled={loading}
              autoFocus
            />
          </div>
          <div className="field">
            <label className="field-label" htmlFor="body">Body</label>
            <textarea
              id="body"
              className="input"
              rows={4}
              value={body}
              onChange={(e) => setBody(e.target.value)}
              required
              disabled={loading}
            />
          </div>
        </form>
        : error ?
        <p>{error}</p>
        :
        <p>Command successfully added.</p>
      }
    </ModalShell>
  );
};

export default AddCommandModal;
